// -----------------------------------------------------------------------------
// Scripts for preloading
// -----------------------------------------------------------------------------

$(document).ready(function() {
  setTimeout(function() {
    $('.preloading').fadeOut('slow');
  }, 300);
});